/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AssessmentOverviewRoute extends Route {
  // Services
  @service
  store;

  model() {
    let store = this.store;
    let group = this.modelFor('group');
    return hash({
      group,
      assessments: store.findAll('assessments/assessment'),
      modules: store.findAll('assessments/module'),
      categories: store.findAll('assessments/category'),
      gradeschedules: store.findAll('assessments/grade-schedule'),
      grades: store.query('assessments/grade', { groupId: group.id }),
    });
  }
}
